/* GDP H1 — GALERIE : pagination du rail + ancrage dans le texte.
   Les pages guides logent tout leur texte dans une seule section (82 Ko pour
   « Quel miel choisir »). Impossible d y intercaler une section Shopify.
   La galerie est donc rendue cote serveur — le HTML contient bien les images
   et leurs attributs alt, rien n est perdu pour le referencement — puis
   replacee au point d ancrage indique.

   DETOX 2026-08-10. La fonction signer() a ete supprimee : elle observait
   chaque carte (IntersectionObserver) pour declencher le trace du paraphe en
   vague a l entree dans le viewport. Le paraphe n existe plus, remplace par le
   filet droit statique 26 x 1 px de la feuille de styles. Plus aucun observer,
   plus aucune classe is-signed : la ligne signature est posee d emblee. */
(function () {
  function placer(sec) {
    var sel = sec.getAttribute('data-h1g-anchor');
    if (!sel) return;
    var hote = sec.parentElement && sec.parentElement.classList.contains('shopify-section')
      ? sec.parentElement : sec;
    var cible;
    try { cible = document.querySelector(sel); } catch (e) { return; }
    if (!cible || cible.contains(hote) || hote.contains(cible)) return;
    var ou = sec.getAttribute('data-h1g-where') || 'after';
    if (ou === 'before') cible.parentNode.insertBefore(hote, cible);
    else cible.parentNode.insertBefore(hote, cible.nextSibling);
  }

  function pager(sec) {
    var rail = sec.querySelector('[data-h1g-rail]');
    var pag = sec.querySelector('[data-h1g-pager]');
    if (!rail || !pag) return;
    var dots = pag.querySelectorAll('i'), tick = false;
    rail.addEventListener('scroll', function () {
      if (tick) return; tick = true;
      requestAnimationFrame(function () {
        tick = false;
        var cells = rail.children, best = 0, bestD = 1e9, r = rail.getBoundingClientRect();
        for (var i = 0; i < cells.length; i++) {
          var d = Math.abs(cells[i].getBoundingClientRect().left - r.left - 16);
          if (d < bestD) { bestD = d; best = i; }
        }
        for (var j = 0; j < dots.length; j++) dots[j].className = (j === best ? 'is-on' : '');
      });
    }, { passive: true });
  }

  function init() {
    var secs = document.querySelectorAll('.h1g');
    for (var i = 0; i < secs.length; i++) { placer(secs[i]); pager(secs[i]); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
